export const SUBMIT_KEYS = new Set(['Enter', ',', ' '])
